import { gql } from '@apollo/client';

export const MUTATION_UPLOAD_PARTNER_LIST = gql`
    mutation uploadExcelFile($fileBase64: String!, $fileName: String!) {
        obtUploadExcelFile(fileBase64: $fileBase64, fileName: $fileName) {
            partnerno
            companycode
            sysid
            category
        }
    }
`;

export const MUTATION_UPLOAD_PARTNER_CONTACTS = gql`
    mutation uploadPartnerContactsFile($fileBase64: String!, $fileName: String!) {
        obtUploadPartnerContactsFile(fileBase64: $fileBase64, fileName: $fileName) {
            idpartner
            partnerno
            companycode
            role
            source
            name1
            name2
            department
            phone
            fax
            mail
        }
    }
`;

export const MUTATION_UPDATE_COMPANY_LEITWEG_ID = gql`
    mutation updateCompanyLeitwegID(
        $leitwegid: String!
        $leitwegsemail: String!
        $idpartner: Float!
        $partnerno: String!
        $companycode: String!
    ) {
        obtUpdateCompanyLeitwegID(
            leitwegid: $leitwegid
            leitwegsemail: $leitwegsemail
            idpartner: $idpartner
            partnerno: $partnerno
            companycode: $companycode
        )
    }
`;

export const MUTATION_DELETE_COMPANY_LEITWEG_ID = gql`
    mutation removeCompanyLeitwegID($idpartner: Float!, $partnerno: String!, $companycode: String!) {
        obtRemoveCompanyLeitwegID(idpartner: $idpartner, partnerno: $partnerno, companycode: $companycode)
    }
`;

export const MUTATION_UPDATE_MASTERPARTNERNO = gql`
    mutation updateMasterPartnerNo($masterpartnerno: String!, $partnerno: String!, $idpartner: Float!) {
        obtUpdateMasterPartnerNo(masterpartnerno: $masterpartnerno, partnerno: $partnerno, idpartner: $idpartner)
    }
`;

export const MUTATION_CANCEL_PARTNER_CHANNEL = gql`
    mutation cancelPartnerChannel($channelId: Float!, $validTo: String!, $status: String!) {
        obtCancelPartnerChannel(channelId: $channelId, validTo: $validTo, status: $status)
    }
`;

export const MUTATION_UPDATE_CONTACT_STATUS = gql`
    mutation updateContactStatus($idContact: Float!) {
        obtUpdateContactStatus(idContact: $idContact)
    }
`;

export const MUTATION_UPDATE_PARTNER_LEGAL_VATCODE = gql`
    mutation updatePartnerLegalVatCode($partnerno: String!, $idpartner: Float!, $vatCode: String!) {
        obtUpdatePartnerLegalVatCode(partnerno: $partnerno, idpartner: $idpartner, vatCode: $vatCode) {
            success
            message
        }
    }
`;

export const MUTATION_DELETE_PARTNER_LEGAL_VATCODE = gql`
    mutation deletePartnerLegalVatCode($partnerno: String!, $idpartner: Float!, $vatCode: String!) {
        obtDeletePartnerLegalVatCode(partnerno: $partnerno, idpartner: $idpartner, vatCode: $vatCode) {
            success
            message
        }
    }
`;

export const MUTATION_UPDATE_COMPANY_PEPPOL_ID = gql`
    mutation updateCompanyPeppolID($peppolId: String!, $idpartner: Float!, $partnerno: String!, $companycode: String!) {
        obtUpdateCompanyPeppolID(
            peppolId: $peppolId
            idpartner: $idpartner
            partnerno: $partnerno
            companycode: $companycode
        )
    }
`;

export const MUTATION_DELETE_COMPANY_PEPPOL_ID = gql`
    mutation removeCompanyPeppolID($idpartner: Float!, $partnerno: String!, $companycode: String!) {
        obtRemoveCompanyPeppolID(idpartner: $idpartner, partnerno: $partnerno, companycode: $companycode)
    }
`;
